import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Button,
  Icon as IconUI,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Header,
  HeaderContent,
  Label,
  Menu,
  Modal,
  Image,
  Popup,
  Tab,
} from "semantic-ui-react";
import { Icon } from "../../assets";
import { AdminMenu, Logout } from "../../components/Admin/AdminLayout";
import "./AdminLayout.scss";
import { useAuth } from "../../hooks";
import { BasicModal, ConfirmDialog } from "../../components/Shared";
import { UserForm } from "../../components/Admin/Users/UserForm";
import { Site, Company, AlertNotifications } from "../../api";
import { useSite } from "../../contexts/SiteContext";
import { formatDateView } from "../../utils/formatDate";
import { useNavigate, useLocation } from "react-router-dom";
import { getModuleHelp } from "../../help/helpContent";
import moment from "moment";
import "moment/locale/es";
import "moment/locale/pt-br";
import { useLanguage } from "../../contexts";
import { useCompany } from "../../contexts/CompanyContext";
import { useZoom } from "../../contexts/ZoomContext";
import { useDashTab } from "../../contexts/DashTabContext";
import { isMaster, isAdmin } from "../../utils/checkPermission";
import logoIcon from "../../assets/svg/isosustemia 2.svg";

const siteController = new Site();
const companyController = new Company();

export function AdminLayout(props) {
  const { children } = props;
  const { user } = useAuth();
  const navigate = useNavigate();
  const { zoom } = useZoom();
  const { changeSite } = useSite();
  const { setActiveTab } = useDashTab();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [reload, onReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  const { language, translations } = useLanguage(); //deberia mantener el estado del idioma crear otro contexto
  //const [language, setLanguage] = useState("Español");

  moment.locale(language === "pt" ? "pt-br" : language);

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const openUpdateUser = () => {
    setTitleModal(`${t("update")} ${user.email}`);
    onOpenCloseModal();
  };

  useEffect(() => {
    if (reload) {
      window.location.reload();
      onReload(false);
    }
  }, [reload]);

  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem("adminMenuCollapsed");
    return saved === "true";
  });

  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const { pathname } = useLocation();
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <div className={`admin-layout ${collapsed ? "collapsed" : ""}`}>
      {menuOpen && (
        <div className="admin-layout__overlay" onClick={() => setMenuOpen(false)} />
      )}
      <div className={`admin-layout__left${menuOpen ? " menu-open" : ""}`}>
        <div style={{ marginTop: "40px" }}></div>
        <AdminMenu collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div className="admin-layout__right">
        <div className="admin-layout__right-header">
          <div
            className="header-brand"
            onClick={() => { navigate("/admin/dashboard"); setActiveTab(0); }}
            onDoubleClick={() => { changeSite(""); navigate("/admin/dashboard"); setActiveTab(0); }}
            title="Ir al Inicio"
            style={{ cursor: "pointer" }}
          >
            <img src={logoIcon} alt="sustemia" className="header-brand__icon" />
            <span className="header-brand__text">sustemia</span>
          </div>
          <div className="header-actions">
            <ZoomControl />
            <LanguageSelector />
            <CompanyLabel />
            <HelpButton />
            <RiskAlertsBell />
            <Profile updateUser={openUpdateUser} t={t} user={user} />
            <button
              className={`hamburger-btn${menuOpen ? " open" : ""}`}
              onClick={toggleMenu}
              aria-label="menu"
            >
              <span className="hamburger-btn__bar" />
              <span className="hamburger-btn__bar" />
              <span className="hamburger-btn__bar" />
            </button>
          </div>
        </div>
        <div className="admin-layout__right-content" style={{ zoom: `${zoom}%` }}>{children}</div>
        <footer className="admin-layout__footer">
          <span>© 2026 Sustemia</span>
          <span className="admin-layout__footer-sep">|</span>
          <a href="/privacidad" className="admin-layout__footer-link">Política de Privacidad</a>
          <span className="admin-layout__footer-sep">|</span>
          <a href="/terminos" className="admin-layout__footer-link">Términos y Condiciones</a>
        </footer>
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={titleModal}
        size={"small"}
      >
        <UserForm close={onOpenCloseModal} onReload={onReload} user={user} />
      </BasicModal>
    </div>
  );
}

const SiteSelector = () => {
  const [listSites, setListSites] = useState([]);
  const { site, changeSite } = useSite();
  const handleChange = (event, data) => {
    changeSite(data.value);
  };
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      const response = await siteController.getSites(accessToken);
      if (response) {
        setListSites(response);
      } else {
        setListSites([]);
      }
    })();
  }, [listSites]);

  return (
    <div
      style={{
        background: "white",
      }}
    >
      <span>
        Sitio{" "}
        <Dropdown
          // placeholder='Selecciona una opción'
          // text='Sitio'
          //button
          //className='icon'
          floating
          labeled
          //icon='world'
          style={{
            background: "transparent",
            boxShadow: "none",
            border: "none",
            color: "black",
          }}
          search
          options={listSites.map((option) => ({
            key: option._id,
            text: option.name,
            value: option._id,
          }))}
          onChange={handleChange}
          value={site}
        />
      </span>
    </div>
  );
};

export default SiteSelector;

function LanguageSelector() {
  const { language, changeLanguage } = useLanguage();
  const [langOpen, setLangOpen] = useState(false);

  return (
    <div
      className={`header-lang-selector${langOpen ? " open" : ""}`}
      onMouseEnter={() => setLangOpen(true)}
      onMouseLeave={() => setLangOpen(false)}
    >
      {langOpen
        ? ["es", "en", "pt"].map((lang) => (
            <span
              key={lang}
              className={`header-lang-opt${language === lang ? " active" : ""}`}
              onClick={() => { changeLanguage(lang); setLangOpen(false); }}
            >
              {lang.toUpperCase()}
            </span>
          ))
        : (
            <span className="header-lang-opt active">
              {(language || "es").toUpperCase()}
            </span>
          )
      }
    </div>
  );
}

function CompanyLabel() {
  const { company, changeCompany } = useCompany();
  const { site, changeSite } = useSite();
  const { accessToken, user } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const canSwitchCompany =
    isMaster(user?.role) || (isAdmin(user?.role) && !user?.company);

  // Admins (even company-restricted) can switch between sites within their company
  const canSwitchSite = isMaster(user?.role) || isAdmin(user?.role);

  const [companies, setCompanies] = useState([]);
  const [sites, setSites] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [siteName, setSiteName] = useState("");

  const fetchCompanies = async () => {
    if (!canSwitchCompany) return;
    const response = await companyController.getCompanies(accessToken, true);
    if (response) setCompanies(response);
  };

  const fetchSites = async () => {
    if (!canSwitchSite || !company || company === "" || company === "0") return;
    const response = await siteController.getSitesByCompany(accessToken, company, true);
    if (response) setSites(response);
  };

  // Refresca al abrir el selector — así una empresa/sitio recién creado en
  // otra pantalla aparece sin necesidad de recargar la página (F5).
  const refreshOnOpen = () => { fetchCompanies(); fetchSites(); };

  useEffect(() => {
    fetchCompanies();
  }, [accessToken, canSwitchCompany]);

  useEffect(() => {
    if (!company || company === "" || company === "0") {
      setSites([]);
      setCompanyName("");
      return;
    }
    if (canSwitchCompany) {
      const found = companies.find((c) => c._id === company);
      setCompanyName(found ? found.name : "");
    } else {
      (async () => {
        const response = await companyController.getCompany(accessToken, company);
        if (response) setCompanyName(response.name || "");
      })();
    }
    if (canSwitchSite) {
      (async () => {
        const response = await siteController.getSitesByCompany(accessToken, company, true);
        if (response) setSites(response);
      })();
    }
  }, [company, companies, canSwitchCompany, canSwitchSite]);

  useEffect(() => {
    if (!site || site === "" || site === "0") { setSiteName(""); return; }
    const found = sites.find((s) => s._id === site);
    setSiteName(found ? found.name : "");
  }, [site, sites]);

  const [open, setOpen] = useState(false);
  // Selector desplegado dentro del panel: null | "company" | "site"
  const [expanded, setExpanded] = useState(null);
  const hasCompany = company && company !== "" && company !== "0";

  const handleOpen = () => {
    refreshOnOpen();
    setExpanded(null);
    setOpen(true);
  };

  const handleCompanyChange = (value) => {
    if (value !== company) {
      setSites([]);
      changeCompany(value);
      changeSite("");
    }
    setExpanded("site");
  };

  const handleSiteChange = (value) => {
    changeSite(value);
    setExpanded(null);
    setOpen(false);
  };

  const toggle = (key) => setExpanded((prev) => (prev === key ? null : key));

  const label = companyName
    ? siteName ? siteName : (sites.length > 0 ? "Total Grupo" : companyName)
    : t("company");

  const triggerContent = isMobile
    ? <IconUI name="building outline" style={{ margin: 0, fontSize: "1.1rem", color: "#1a1c40" }} />
    : label;

  const clickableTriggerContent = isMobile
    ? triggerContent
    : (
      <>
        <span className="header-company-label__text">{label}</span>
        <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="12" height="12" className="header-company-label__arrow" aria-hidden="true">
          <path d="M6 1.5v9M2.5 7 6 10.5 9.5 7"/>
        </svg>
      </>
    );

  // No permissions to interact — read-only label
  if (!canSwitchCompany && !canSwitchSite) {
    return (
      <span className="header-company-label">
        {triggerContent}
      </span>
    );
  }

  const optionClass = (active) =>
    `company-selector-option${active ? " company-selector-option--active" : ""}`;

  const fieldClass = (key, disabled) =>
    `company-selector-field${expanded === key ? " company-selector-field--open" : ""}` +
    `${disabled ? " company-selector-field--disabled" : ""}`;

  const siteDisabled = !hasCompany;

  return (
    <Popup
      className="company-selector-popover"
      on="click"
      position="bottom right"
      open={open}
      onOpen={handleOpen}
      onClose={() => setOpen(false)}
      trigger={
        <span className="header-company-label header-company-label--clickable">
          {clickableTriggerContent}
        </span>
      }
      content={
        <div className="company-selector-popup">
          {/* Empresa */}
          <button type="button" className={fieldClass("company", !canSwitchCompany)}
            disabled={!canSwitchCompany} onClick={() => toggle("company")}>
            <span className="company-selector-field__text">{companyName || t("company")}</span>
            {canSwitchCompany && (
              <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="12" height="12" className="company-selector-field__arrow" aria-hidden="true">
                <path d="M6 1.5v9M2.5 7 6 10.5 9.5 7"/>
              </svg>
            )}
          </button>
          {expanded === "company" && (
            <div className="company-selector-options">
              {companies.length === 0 && <div className="company-selector-empty">{t("no_data")}</div>}
              {companies.map((c) => (
                <button type="button" key={c._id} className={optionClass(c._id === company)}
                  onClick={() => handleCompanyChange(c._id)}>
                  {c.name}
                </button>
              ))}
            </div>
          )}

          {/* Sitio */}
          <button type="button" className={fieldClass("site", siteDisabled)}
            disabled={siteDisabled} onClick={() => toggle("site")}>
            <span className="company-selector-field__text">
              {hasCompany ? (siteName || "Total Grupo") : t("site")}
            </span>
            <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="12" height="12" className="company-selector-field__arrow" aria-hidden="true">
              <path d="M6 1.5v9M2.5 7 6 10.5 9.5 7"/>
            </svg>
          </button>
          {expanded === "site" && (
            <div className="company-selector-options">
              <button type="button" className={optionClass(!site || site === "0")}
                onClick={() => handleSiteChange("")}>
                Total Grupo
              </button>
              {sites.map((s) => (
                <button type="button" key={s._id} className={optionClass(s._id === site)}
                  onClick={() => handleSiteChange(s._id)}>
                  {s.name}
                </button>
              ))}
            </div>
          )}
        </div>
      }
    />
  );
}

function ZoomControl() {
  const { zoom, zoomIn, zoomOut } = useZoom();
  return (
    <div className="header-zoom-control">
      <button className="header-zoom-btn" onClick={zoomOut} disabled={zoom <= 40}>−</button>
      <span className="header-zoom-label">{zoom}%</span>
      <button className="header-zoom-btn" onClick={zoomIn} disabled={zoom >= 120}>+</button>
    </div>
  );
}

const alertCtrl = new AlertNotifications();

const DOT_COLORS = { critico: "#B23030", alto: "#E07020", warn: "#F4B83B", info: "#3B82F6" };

const MODULE_META = {
  riskAssessment:    { icon: "⚠️", label: "bell_mod_risk",    hasThreshold: false },
  actionPlan:        { icon: "🎯", label: "bell_mod_action",  hasThreshold: true,  thresholdKey: "daysBeforeDue",    thresholdLabel: "bell_days_before" },
  annualPlan:        { icon: "📅", label: "bell_mod_annual",   hasThreshold: true,  thresholdKey: "daysBeforeDue",    thresholdLabel: "bell_days_before" },
  legalRequirements: { icon: "⚖️", label: "bell_mod_legal",   hasThreshold: true,  thresholdKey: "daysBeforeExpiry", thresholdLabel: "bell_days_before" },
  workPermits:       { icon: "🔐", label: "bell_mod_permits", hasThreshold: false },
  // Varios umbrales: días de pre-aviso de vencimiento + meses para considerarla desactualizada
  evidences:         { icon: "📄", label: "bell_mod_evidence", hasThreshold: true, thresholds: [
    { key: "daysBeforeExpiry", def: 30, unit: "days",   max: 365 },
    { key: "maxAgeMonths",     def: 12, unit: "months", max: 60  },
  ] },
};

// Lista de umbrales de un módulo (los módulos viejos tienen uno solo)
function moduleThresholds(meta) {
  if (meta.thresholds) return meta.thresholds;
  if (!meta.hasThreshold) return [];
  return [{ key: meta.thresholdKey, def: meta.thresholdKey === "daysBeforeExpiry" ? 30 : 7, unit: "days", max: 365 }];
}

const SETTINGS_LS  = "sst_alert_settings";
const DISMISSED_SS = "sst_alert_dismissed";

function alertKey(a) { return `${a.module}:${a.level}:${a.title}:${a.sub || ""}`; }

function readDismissed() {
  try { return new Set(JSON.parse(sessionStorage.getItem(DISMISSED_SS)) || []); }
  catch { return new Set(); }
}
function writeDismissed(s) { sessionStorage.setItem(DISMISSED_SS, JSON.stringify([...s])); }

function readCachedSettings() {
  try { return JSON.parse(localStorage.getItem(SETTINGS_LS)) || null; }
  catch { return null; }
}
function writeCachedSettings(s) { localStorage.setItem(SETTINGS_LS, JSON.stringify(s)); }

function RiskAlertsBell() {
  const { accessToken, user } = useAuth();
  // Avisos de vencimiento de evidencias: master, admin y editor (los que
  // pueden subir el documento renovado). El buscador sigue siendo solo master.
  const canEvidenceAlerts = ["master", "admin", "administrador", "editor"].includes(user?.role?.name?.toLowerCase());
  const { company: selCompany } = useCompany();
  const { site: selSite } = useSite();
  const navigate = useNavigate();
  const { translations } = useLanguage();
  const t = key => translations[key] || key;
  const LEVEL_T = { CRITICO: "ra_level_critical", ALTO: "ra_level_high", MODERADO: "ra_level_moderate", BAJO: "ra_level_low" };
  const tMsg = (key, params) => {
    let str = translations[key] || key;
    if (params) {
      const p = { ...params };
      if (p.level && LEVEL_T[p.level]) p.level = translations[LEVEL_T[p.level]] || p.level;
      Object.entries(p).forEach(([k, v]) => { str = str.replace(new RegExp(`\\{${k}\\}`, "g"), v); });
    }
    return str;
  };

  const [alerts,    setAlerts]    = useState([]);
  const [open,      setOpen]      = useState(false);
  const [view,      setView]      = useState("alerts");
  const [settings,  setSettings]  = useState(() => readCachedSettings());
  const [saving,    setSaving]    = useState(false);
  const [dismissed, setDismissed] = useState(readDismissed);
  const [collapsed, setCollapsed] = useState(new Set());
  const panelRef = useRef(null);
  const bellRef  = useRef(null);

  // ── Load alerts ──────────────────────────────────────────────────────────
  const loadAlerts = useCallback(() => {
    if (!accessToken) return;
    alertCtrl.getAlerts(accessToken, { company: selCompany, site: selSite })
      .then(res => setAlerts(Array.isArray(res.alerts) ? res.alerts : []))
      .catch(() => {});
  }, [accessToken, selCompany, selSite]);

  useEffect(loadAlerts, [loadAlerts]);

  // Polling cada 5 minutos
  useEffect(() => {
    const id = setInterval(loadAlerts, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, [loadAlerts]);

  // Recargar al volver al tab
  useEffect(() => {
    const handler = () => { if (!document.hidden) loadAlerts(); };
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }, [loadAlerts]);

  // Cerrar al click fuera
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target) &&
          bellRef.current  && !bellRef.current.contains(e.target)) {
        setOpen(false); setView("alerts");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  // Cargar settings al abrir configuración (cache primero, luego server)
  useEffect(() => {
    if (view !== "settings" || !accessToken) return;
    alertCtrl.getSettings(accessToken)
      .then(s => { setSettings(s); writeCachedSettings(s); })
      .catch(() => {});
  }, [view, accessToken]);

  // ── Handlers ─────────────────────────────────────────────────────────────
  const handleToggle = (mod) =>
    setSettings(prev => ({ ...prev, [mod]: { ...prev[mod], enabled: !prev[mod]?.enabled } }));

  const handleThreshold = (mod, key, val) => {
    const n = parseInt(val, 10);
    if (!isNaN(n) && n >= 1)
      setSettings(prev => ({ ...prev, [mod]: { ...prev[mod], [key]: n } }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const saved = await alertCtrl.saveSettings(accessToken, settings);
      writeCachedSettings(saved);
      setSettings(saved);
      loadAlerts();
      setView("alerts");
    } catch { /* mantener panel abierto */ }
    finally { setSaving(false); }
  };

  const dismissAlert = (a, e) => {
    e.stopPropagation();
    const next = new Set([...dismissed, alertKey(a)]);
    setDismissed(next);
    writeDismissed(next);
  };

  const toggleCollapse = (mod) => {
    setCollapsed(prev => {
      const next = new Set(prev);
      next.has(mod) ? next.delete(mod) : next.add(mod);
      return next;
    });
  };

  const closePanel = () => { setOpen(false); setView("alerts"); };

  // ── Derived data ──────────────────────────────────────────────────────────
  const visible = alerts.filter(a => !dismissed.has(alertKey(a)));

  const grouped = Object.entries(MODULE_META)
    .map(([mod, meta]) => ({ mod, meta, items: visible.filter(a => a.module === mod) }))
    .filter(g => g.items.length > 0);

  const criticos = visible.filter(a => a.level === "critico").length;
  const altos    = visible.filter(a => a.level === "alto").length;
  const avisos   = visible.filter(a => a.level === "warn" || a.level === "info").length;

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      <button
        ref={bellRef}
        className={`bell-btn${visible.length > 0 ? " has-alerts" : ""}`}
        onClick={() => setOpen(o => !o)}
        title={t("bell_alerts")}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        {visible.length > 0 && (
          <span className="bell-badge">{visible.length > 99 ? "99+" : visible.length}</span>
        )}
      </button>

      {open && (
        <div className="alert-panel" ref={panelRef}>

          {/* ── Vista alertas ── */}
          {view === "alerts" && (
            <>
              <div className="alert-panel-head">
                <div className="alert-panel-head__summary">
                  <h4>{t("bell_alerts")}</h4>
                  <div className="alert-level-chips">
                    {criticos > 0 && <span className="alc alc--critico">{criticos} {t(criticos !== 1 ? "bell_criticas_pl" : "bell_critica")}</span>}
                    {altos    > 0 && <span className="alc alc--alto">{altos} {t(altos !== 1 ? "bell_altas_pl" : "bell_alta")}</span>}
                    {avisos   > 0 && <span className="alc alc--warn">{avisos} {t(avisos !== 1 ? "bell_avisos_pl" : "bell_aviso")}</span>}
                  </div>
                </div>
                <div className="alert-panel-head__actions">
                  <button className="alert-panel-gear" onClick={() => setView("settings")} title={t("bell_config_alerts")}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                      <circle cx="12" cy="12" r="3"/>
                      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                    </svg>
                  </button>
                  <button className="alert-panel-close" onClick={closePanel}>✕</button>
                </div>
              </div>

              <div className="alert-panel-list">
                {grouped.length === 0 ? (
                  <div className="alert-empty">
                    <div style={{ fontSize: 28, marginBottom: 8 }}>🔔</div>
                    {t("bell_no_alerts")}
                    <div style={{ marginTop: 8, fontSize: 11 }}>
                      <button className="alert-config-link" onClick={() => setView("settings")}>{t("bell_config_modules")}</button>
                    </div>
                  </div>
                ) : (
                  grouped.map(({ mod, meta, items }) => {
                    const isCollapsed = collapsed.has(mod);
                    return (
                      <div key={mod} className="alert-group">
                        <button className="alert-group-hd" onClick={() => toggleCollapse(mod)}>
                          <span className="alert-group-hd__left">
                            <span>{meta.icon}</span>
                            <span className="alert-group-hd__label">{t(meta.label)}</span>
                            <span className="alert-group-hd__count">{items.length}</span>
                          </span>
                          <span className={`alert-group-chevron${isCollapsed ? " collapsed" : ""}`}>›</span>
                        </button>
                        {!isCollapsed && items.map((a, i) => (
                          <div key={i} className="alert-item" onClick={() => { if (a.link) navigate(a.link); closePanel(); }}>
                            <div className="alert-dot" style={{ background: DOT_COLORS[a.level] || "#9CA3AF" }} />
                            <div className="alert-body">
                              <b>{a.msgKey ? tMsg(a.msgKey, a.msgParams) : a.title}</b>
                              {a.sub && <small>{a.sub}</small>}
                            </div>
                            <button className="alert-dismiss" onClick={e => dismissAlert(a, e)} title={t("bell_dismiss")}>✕</button>
                          </div>
                        ))}
                      </div>
                    );
                  })
                )}
              </div>
            </>
          )}

          {/* ── Vista configuración ── */}
          {view === "settings" && (
            <>
              <div className="alert-panel-head">
                <div className="alert-panel-head__back">
                  <button className="alert-panel-back" onClick={() => setView("alerts")}>←</button>
                  <h4>{t("bell_config_alerts")}</h4>
                </div>
                <button className="alert-panel-close" onClick={closePanel}>✕</button>
              </div>
              <div className="alert-settings-body">
                {settings === null ? (
                  <div className="alert-empty">{t("bell_loading")}</div>
                ) : (
                  <>
                    <p className="alert-settings-hint">
                      {t("bell_settings_hint")}
                    </p>
                    {Object.entries(MODULE_META).filter(([mod]) => mod !== "evidences" || canEvidenceAlerts).map(([mod, meta]) => {
                      const s = settings[mod] || {};
                      return (
                        <div key={mod} className={`alert-settings-row${s.enabled ? " enabled" : ""}`}>
                          <div className="alert-settings-row__info">
                            <span className="alert-settings-icon">{meta.icon}</span>
                            <span className="alert-settings-label">{t(meta.label)}</span>
                          </div>
                          <div className="alert-settings-row__controls">
                            {s.enabled && moduleThresholds(meta).map(th => (
                              <div key={th.key} className="alert-settings-threshold">
                                <input
                                  type="number" min="1" max={th.max}
                                  value={s[th.key] ?? th.def}
                                  onChange={e => handleThreshold(mod, th.key, e.target.value)}
                                />
                                <span className="alert-settings-threshold__label">{t(th.unit)}</span>
                              </div>
                            ))}
                            <button
                              className={`alert-toggle${s.enabled ? " on" : ""}`}
                              onClick={() => handleToggle(mod)}
                              title={s.enabled ? t("deactivate") : t("activate")}
                            >
                              <span className="alert-toggle__knob" />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                    <div className="alert-settings-footer">
                      <button className="alert-settings-save" onClick={handleSave} disabled={saving}>
                        {saving ? t("bell_saving") : t("bell_save_changes")}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </>
          )}

        </div>
      )}
    </>
  );
}

function HelpButton() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { language, translations } = useLanguage();
  const tHelp = key => translations[key] || key;
  const { label, sub, panes } = getModuleHelp(pathname, language);

  return (
    <>
      <button
        className="help-btn"
        onClick={() => setOpen(true)}
        title={tHelp("help_desk")}
        aria-label={tHelp("help_desk")}
      >
        <span className="help-btn__icon">?</span>
      </button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size="large"
        className="help-modal"
      >
        <div className="help-modal__header">
          <div className="help-modal__title-row">
            <span className="help-modal__badge">?</span>
            <span className="help-modal__title">{tHelp("help_desk")} — {label}</span>
            <button className="help-modal__close" onClick={() => setOpen(false)}>✕</button>
          </div>
          <div className="help-modal__sub">{sub}</div>
        </div>
        <Modal.Content scrolling className="help-modal__content">
          <Tab
            menu={{ secondary: true, pointing: true, className: "help-modal__tabs" }}
            panes={panes}
          />
        </Modal.Content>
      </Modal>
    </>
  );
}


function Profile(props) {
  const { updateUser, t, user } = props;
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const onOpenCloseConfirm = () => setShowConfirm((prev) => !prev);

  const handleLogout = () => {
    logout();
    navigate("/admin");
  };

  const displayName = user?.username || user?.firstname || user?.email?.split("@")[0] || "";
  const initials = displayName.slice(0, 2).toUpperCase();

  return (
    <>
      <Dropdown
        trigger={
          <span className="profile-avatar">
            {initials}
          </span>
        }
        icon={null}
        pointing="top right"
        className="header-menu-dropdown"
      >
        <DropdownMenu className="profile-dropdown-menu">
          <div className="profile-dropdown-header">
            <span className="profile-avatar profile-avatar--lg">{initials}</span>
            <div className="profile-dropdown-info">
              <span className="profile-dropdown-name">{displayName}</span>
              <span className="profile-dropdown-email">{user?.email}</span>
            </div>
          </div>
          <div className="profile-dropdown-divider" />
          <DropdownItem onClick={updateUser} className="profile-dropdown-item">
            <IconUI name="setting" className="profile-dropdown-item__icon" />
            {t("edit_profile")}
          </DropdownItem>
          <div className="profile-dropdown-divider" />
          <DropdownItem onClick={onOpenCloseConfirm} className="profile-dropdown-item profile-dropdown-item--danger">
            <IconUI name="sign out" className="profile-dropdown-item__icon" />
            {t("logout")}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <BasicModal show={showConfirm} close={onOpenCloseConfirm} size="tiny" className="logout-confirm-modal">
        <h3 className="logout-confirm__title">{t("logout")}</h3>
        <div className="logout-confirm__divider" />
        <p className="logout-confirm__text">{t("are_you_sure_you_want_to_log_out")}</p>
        <div className="logout-confirm__actions">
          <Button primary size="small" onClick={handleLogout}>{t("accept")}</Button>
          <Button secondary size="small" onClick={onOpenCloseConfirm}>{t("cancel")}</Button>
        </div>
      </BasicModal>
    </>
  );
}
